import moment from "moment";
import "moment/locale/bs";
import IModuleContainer from "./runtime/IModuleContainer";
import ModuleContainer from "./runtime/ModuleContainer";
import { IRouter, Router } from "./runtime/Router";
import { IArea } from "./core/areas/Area";
import HandleApplicationErrorInteractor from "./core/interactor/app/HandleApplicationErrorInteractor";
import { IStore } from "./core/model/runtime/state/Store";
import { Action, To } from "history";
import ApplicationConfig from "./ApplicationConfig";
import { ILocaleProvider } from "./core/service/locale/LocaleProvider";
import { AppConstants } from "./core/common/Constants";
import GetSelectedLanguageInteractor from "./core/interactor/language/GetSelectedLanguageInteractor";
//Zakomentarisane izmjene će biti potrebno vratiti kada ponovno budemo prebacili prevode u messages.properties
export default class Application {
  private _router: IRouter;
  private _container: IModuleContainer;
  // private _localeProvider: IAsyncLocaleProvider;

  private _localeProvider: ILocaleProvider;
  private _appConfig: ApplicationConfig;

  get container() {
    return this._container;
  }

  get navigator() {
    return this._router;
  }

  get localeProvider() {
    return this._localeProvider;
  }
  get applicationName() {
    return this._appConfig.getApplicationName();
  }

  isPortal() {
    return this._appConfig.getApplicationName() === AppConstants.PORTAL;
  }
  constructor(appName: string, context: any, rootElement: HTMLElement) {
    this._appConfig = new ApplicationConfig(appName);
    this._container = ModuleContainer(this);
    this._router = Router(
      context,
      rootElement,
      this,
      [],
      this._appConfig.layouts
    );
    this._container.registerValue("router", this._router);
    // this._localeProvider =
    // this.container.resolve<IAsyncLocaleProvider>("localeProvider");
    this._localeProvider =
      this.container.resolve<ILocaleProvider>("localeProvider");

    moment.locale(this._localeProvider.getCurrentLanguage());
    window["__secretApplication"] = this;
  }

  private registerGlobalErrorHandler() {
    const _container = this.container;
    window.addEventListener("unhandledrejection", function (e) {
      var reason = e.reason ? e.reason : e.type;

      e.preventDefault();
      if (!(e as any).reason.handled) {
        _container
          .resolve<HandleApplicationErrorInteractor>("handleApplicationError")
          .execute(reason);
      }
    });
  }

  public changeSystemLanguage(languageCode: string) {
    this._container.registerValue("language", languageCode);
  }

  private registerAreas(areas: string[]) {
    areas.forEach((area) => {
      this._container.resolve<IArea>(`${area}Area`).register();
    });
  }

  async start() {
    let currentLanguage = await this.container
      .resolve<GetSelectedLanguageInteractor>("getSelectedLanguage")
      .execute();

    if (!currentLanguage) {
      currentLanguage = this._container.resolve<string>("language");

      this.changeSystemLanguage(currentLanguage);
    }
    // const translations = await this.localeProvider.fetch(currentLanguage);
    // this.localeProvider.addLocale(currentLanguage, translations);
    this.localeProvider.changeCurrentLanguage(currentLanguage);
    this.registerAreas(this._appConfig.areas);
    this._router.bindLocationListener();
    this._router.showLocation({
      action: Action.Push,
      location: {
        pathname: window.location.pathname,
        search: window.location.search
      } as To
    });

    this.registerGlobalErrorHandler();
  }

  public get store() {
    return this._container.resolve<IStore>("store");
  }

  addLocale(locale: string, translations = {}) {
    if (locale) {
      this.localeProvider.addLocale(locale, translations);
    }
  }
}
